import { Analytics } from '@cobliteam/analytics';
import AlertIcon from '@cobliteam/business-manager/src/components/AlertIcon';
import { Location } from '@cobliteam/common-types';
import { useBoletoAtrasados, useMultipleContractMenu } from '@cobliteam/hooks/src/useEntity/useBusinessManager';
import useFeatureFlags from '@cobliteam/hooks/src/useFeatureFlags';
import Button from '@cobliteam/ui/components/Button';
import Tooltip from '@cobliteam/ui/components/Tooltip';
import Icon from '@cobliteam/ui/icons';
import { useHistory } from 'react-router-dom';

const BoletosButton = () => {
  const featureFlags = useFeatureFlags();
  const history = useHistory();
  const { data: multipleContracts } = useMultipleContractMenu({ enabled: featureFlags.alertBoletos });
  const { data: overdueBoletos } = useBoletoAtrasados(multipleContracts);

  const hasOverdueBoletos = overdueBoletos?.length > 0;

  const handleClick = () => {
    Analytics.track('NavBar - Boletos - Click');
    history.push(Location.BUSINESS_MANAGER_BOLETOS);
  };

  if (!featureFlags.alertBoletos) return null;
  if (!hasOverdueBoletos) return null;

  return (
    <Tooltip content='Existe um ou mais boletos atrasados' asChild className='w-32' position='left'>
      <div className='relative pt-4'>
        <Button data-testid='app-header-boletos-button' variant='surface' color='danger' size='sm' icon={<Icon name='dollar-sign' />} onClick={handleClick} />
        {hasOverdueBoletos && (
          <div className='-right-1 absolute top-2 flex items-center justify-center'>
            <AlertIcon size='xs' />
          </div>
        )}
      </div>
    </Tooltip>
  );
};

export default BoletosButton;
